import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const ServicesSection = () => {
  const services = [
    {
      id: 1,
      icon: 'ri-star-line',
      title: 'Astroloji',
      subtitle: 'Astrolojik Danışmanlık',
      description: 'Doğum haritanız, gezegensel geçişler ve yıldızların size özel mesajlarıyla hayatınıza yön verin.',
      link: '/hizmetler/astrolojik-danismanlik',
      image: 'https://public.readdy.ai/ai/img_res/34d9ebb5137e053f74dbdab0ec88dc33.jpg'
    },
    {
      id: 2,
      icon: 'ri-sparkling-line',
      title: 'Spiritüel',
      subtitle: 'Spiritüel Danışmanlık',
      description: 'Ruhsal gelişim yolculuğunuzda rehberlik, içsel farkındalık ve kişisel dönüşüm desteği.',
      link: '/hizmetler/spirituel-danismanlik',
      image: 'https://readdy.ai/api/search-image?query=serene%20spiritual%20meditation%20scene%20with%20soft%20golden%20light%20rays%20illuminating%20peaceful%20energy%2C%20floating%20ethereal%20particles%20and%20gentle%20aurora%20colors%2C%20minimalist%20zen%20atmosphere%20with%20clean%20background%2C%20premium%20spiritual%20guidance%20aesthetic&width=800&height=600&seq=spirit-service-1&orientation=landscape'
    },
    {
      id: 3,
      icon: 'ri-heart-pulse-line',
      title: 'Enerji',
      subtitle: 'Şifa & Enerji Çalışmaları',
      description: 'Enerji dengeleme, şifa seansları ve frekans çalışmalarıyla bedeninizi ve ruhunuzu uyumlu hale getirin.',
      link: '/hizmetler/sifa-enerji',
      image: 'https://readdy.ai/api/search-image?query=healing%20energy%20waves%20with%20glowing%20golden%20and%20turquoise%20light%20frequencies%2C%20crystal%20formations%20emitting%20soft%20radiant%20energy%2C%20peaceful%20chakra%20balance%20visualization%20with%20clean%20minimal%20background%2C%20premium%20energy%20healing%20aesthetic&width=800&height=600&seq=energy-service-1&orientation=landscape'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="font-serif text-4xl lg:text-5xl font-bold text-primary-dark mb-4">
            Hizmetlerim
          </h2>
          <p className="text-text-medium text-lg max-w-2xl mx-auto">
            Size özel danışmanlık ve şifa hizmetleriyle hayatınıza yeni bir perspektif kazandırın
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={service.id}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              className="group bg-cream rounded-3xl overflow-hidden hover:shadow-2xl transition-all duration-500"
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-primary-dark/80 to-transparent"></div>
                <div className="absolute bottom-6 left-6">
                  <div className="w-14 h-14 bg-gold/90 rounded-full flex items-center justify-center mb-3">
                    <i className={`${service.icon} text-primary-dark text-2xl`}></i>
                  </div>
                  <h3 className="font-serif text-2xl font-bold text-white">{service.title}</h3>
                </div>
              </div>

              <div className="p-8">
                <h4 className="font-serif text-xl font-bold text-primary-dark mb-3">
                  {service.subtitle}
                </h4>
                <p className="text-text-medium leading-relaxed mb-6">
                  {service.description}
                </p>
                <Link
                  to={service.link}
                  className="inline-flex items-center space-x-2 text-gold font-semibold hover:space-x-4 transition-all duration-300 cursor-pointer"
                >
                  <span>Detayları Gör</span>
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;